'use client';

/** @jsxImportSource @emotion/react */
import { useTranslations } from 'next-intl';
import BringOrder from '@/components/bring-order/BringOrder';

const AIBringOrderSection = () => {
  const t = useTranslations('AIBringOrderSection');

  return (
    <BringOrder
      title={t('title')}
      description={t('description')}
      primaryBtn={t('primaryButtonLabel')}
      showPrimaryButton={false}
      secondaryBtn={t('secondaryButtonLabel')}
      secondaryBtnTargetId="contact"
    />
  );
};

export default AIBringOrderSection;
